module.exports = __webpack_public_path__ + "img/oculus_lofi_prototype.2f40b8d2.png";